import { render, staticRenderFns } from "./SecurityPage.vue?vue&type=template&id=480a2e6e&scoped=true"
import script from "./SecurityPage.vue?vue&type=script&lang=js"
export * from "./SecurityPage.vue?vue&type=script&lang=js"
import style0 from "./SecurityPage.vue?vue&type=style&index=0&id=480a2e6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480a2e6e",
  null
  
)

export default component.exports